import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'
import TrackingsModule from '../components/TrackingsModule';
import { GetSchoolUnitTrackings } from '../../../store/SchoolAction';
import { RequestState } from '../../../models/RequestState';
import { CoreTracking } from '../../../models/CoreTracking';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store/store';



const SchoolUnitViewTrackings = () => {
    const { t } = useTranslation(['schoolAdministration']);

    const { schoolId } = useParams();
    const dispatch = useDispatch();
    const trackings = useSelector<RootState, RequestState<CoreTracking[]>>(state => state.schools.schoolTrackings);

    useEffect(() => {
        if (schoolId !== undefined) {
            GetSchoolUnitTrackings(schoolId)(dispatch);
        }
    }, [dispatch, schoolId]);

    return (<>
        <TrackingsModule
            trackings={trackings}
            noResMsg={t('trackingModule.noResMsg', { ns: 'schoolAdministration', type: t('type.school', { ns: 'schoolAdministration' }) })}
        />
    </>)
}

export default SchoolUnitViewTrackings;
